import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-carrier-profiles-anniversary',
  template: require('./linescape-carrier-profiles-anniversary.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-carrier-profiles-anniversary.component.scss')]
})
export class LinescapeCarrierProfilesAnniversaryComponent extends BlogPage {
  title = "Linescape celebrates 1st Anniversary with Carrier Profiles - Linescape";
  description = "Sailing Schedules Website Adds Carrier Profile and Fleet Information.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-carrier-profiles-anniversary/linescape-carrier-profiles-anniversary.component.ts